import useChangeModeByUrl from "../useChangeModeByUrl";
import useJanus from "../useJanus";
import { useContext, useEffect } from "react";
import { TEST_MODE } from "../../components/common/consts";
import { useAppSelector } from "../../store/index.ts";
import { AudioContextRef, VideoContextRef } from "../../pages/CurrentModel.jsx";

export default function useInitJanus() {
  const audioRef = useContext(AudioContextRef);
  const videoRef = useContext(VideoContextRef);
  const broadcasterId = useAppSelector((state) => state.chat.broadcaster.id);
  const broadcasterChatId = useAppSelector((state) => state.chat.broadcaster?.chat?.id);

  const janusOptions = {
    broadcasterId: broadcasterId,
    chatId: broadcasterChatId,
    videoRef: videoRef,
    audioRef: audioRef,
  };

  const { changeChatMode } = useJanus(janusOptions);
  useChangeModeByUrl(changeChatMode);

  useEffect(() => {
    if (!TEST_MODE) return;
    navigator.mediaDevices
      .getUserMedia({
        video: {
          width: { exact: 1920 },
          height: { exact: 1080 },
        },
        audio: false,
      })
      .then((stream) => {
        videoRef.current.srcObject = stream;
      });
  }, []);
}
